import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Arrows.module.css';
import Button from '../../../Button';

const bindClasses = classNameBind.bind(styles);

const Arrows = ({ rightOnClick, rightDisabled, leftOnClick, leftDisabled }) => (
  <div className={bindClasses('wrapper')} data-ppuc-id="Transfer.Arrows">
    <div className={bindClasses('sticky')}>
      <div className={bindClasses('right')}>
        <Button
          onClick={rightOnClick}
          disabled={rightDisabled}
          icon="arrow-right"
          dataId="arrow-right"
        />
      </div>
      <div className={bindClasses('left')}>
        <Button
          onClick={leftOnClick}
          disabled={leftDisabled}
          icon="arrow-left"
          dataId="arrow-left"
        />
      </div>
    </div>
  </div>
);

export default Arrows;
